export const addOnPocketMap = [
    { value: "None", id: 0, price: 0, },
    { value: "Regular", id: 0, price: 10, },
]